export const BASE_URL =
    process.env.REACT_APP_SRS_ENV === 'production' // eslint-disable-line no-undef
        ? 'https://pov-srs.project.synpulse8.com/api/main/srs-analytics-svc/analytics/v1'
        : process.env.REACT_APP_SRS_ENV === 'development' // eslint-disable-line no-undef
        ? 'https://pov-srs.project.synpulse8.com/api/dev/srs-analytics-svc/analytics/v1'
        : 'http://localhost:1032/analytics/v1';

export const SCENARIO_BASE_URL = `${BASE_URL}/scenario/`;
export const ZONES_BASE_URL = `${BASE_URL}/zones`;
export const FILTERS_BASE_URL = `${BASE_URL}/filters`;
export const MAIN_STATS_BASE_URL = `${BASE_URL}/main-stats`;
export const LAST_REFRESH_DATE_URL = `${BASE_URL}/last-refresh-date`;
export const SETTINGS_URL = `${BASE_URL}/settings/threshold-settings`;
export const THRESHOLD_OVERRIDES_URL = `${BASE_URL}/add/threshold-overrides`;
export const TIMESLICER_END_MONTH_API_URL = `${BASE_URL}/time-slicer-end-month`;

export const TOP_RANKS_URL = `${BASE_URL}/top-ranks`;
export const TOP_AND_EMERGING_SPIKES_URL = `${BASE_URL}/top-and-emerging-spikes`;
export const LANDING_PAGE_SCENARIO_STATS_URL = `${BASE_URL}/scenario-stats`;
export const MARKET_PAGE_SCENARIO_STATS_URL = `${BASE_URL}/scenario-stats`;
export const TEAM_PAGE_SCENARIO_STATS_URL = `${BASE_URL}/scenario-stats`;
export const PEER_COMPARISON = `${BASE_URL}/peer-comparison`;
export const TREND = `${BASE_URL}/trend`;

export const RM_PAGE_SCENARIO_STATS_URL = `${BASE_URL}/rm-scenario-stats`;
export const RM_TREND_ANALYSIS_URL = `${BASE_URL}/trend`;
export const RM_PEER_COMPARISON__URL = `${BASE_URL}/peer-comparison`;
export const RM_PAGE_INVESTIGATION_DATA_URL = `${BASE_URL}/rm-investigation`;
export const RM_SUBMIT_INVESTIGATION_URL = `${BASE_URL}/add/rm-investigation`;
export const RM_SCORE_DECOMPOSITION = `${BASE_URL}/rm-score-decomposition`;
